import { Component, Injector, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';
import {
  LoggerService,
  RecordItem,
  RecordListLocator,
  ViewDataConfigStruct,
  ViewDataService,
  WaHelperService
} from 'world-archery-lib';

@Component({
  selector: 'app-world-records-broken-panel',
  templateUrl: './world-records-broken-panel.component.html',
  styleUrls: ['./world-records-broken-panel.component.scss']
})
export class WorldRecordsBrokenPanelComponent extends DrupalLangClass implements OnInit {
  RecordsList: RecordItem[];
  loading = true;
  constructor(
    protected logger: LoggerService,
    protected views: ViewDataService,
    protected helper: WaHelperService,
    injector: Injector,
    ) {
      super(injector);

    }

  ngOnInit() {
    this.getDataStream().subscribe((next : RecordItem[]) => {
      next.forEach(value => {
        if ((value.athlete instanceof Array) === false && value.isTeam === false) {
            value.athlete = [value.athlete] as any;
        }
        if(value.isTeam !== false && value.teamName !== undefined && typeof value.teamName === 'string' ){
          value.athlete = [{fName:value.teamName, noc:value.noc}] as any;
        }
      });

      this.RecordsList = next;
      this.loading = false;
    });
  }
  getCategoryName(catCode: string) {
    return this.helper.getCategoryInfoByCode(catCode).name;
  }
  getDataStream(): Observable<Array<RecordItem>> {
    const categoriesLocatorByRecords = new RecordListLocator();
    categoriesLocatorByRecords.team.value = undefined;
    categoriesLocatorByRecords.isPara.value = undefined;
    categoriesLocatorByRecords.sortrank.sortingType = 'DATE' as any;
    categoriesLocatorByRecords.sortrank.asc = false;
    const infoItem: ViewDataConfigStruct = {
      maxAge: 1800,
      interval: undefined,
      autorefresh: false,
      expectedItems: 5
    };
    const view = this.views.get(categoriesLocatorByRecords);
    view.applyConfiguration(infoItem);
    return view.getDataStream();
  }
}
